import { render, staticRenderFns } from "./PanelDetail.vue?vue&type=template&id=543063fa&scoped=true"
import script from "./PanelDetail.vue?vue&type=script&lang=js"
export * from "./PanelDetail.vue?vue&type=script&lang=js"
import style0 from "./PanelDetail.vue?vue&type=style&index=0&id=543063fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543063fa",
  null
  
)

export default component.exports